module.exports = __webpack_public_path__ + "img/switch-camera.a00458b1.svg";